import React from 'react';
import { useTranslation } from 'react-i18next';

const Differentiators = () => {
  const { t } = useTranslation();

  return (
    <section
      id="diff"
      className="bf-section"
      style={{
        background: 'var(--bf-bg-alt)',
        color: '#fff',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: -200,
          right: -200,
          width: 600,
          height: 600,
          background: 'radial-gradient(circle, rgba(240,31,61,0.22) 0%, transparent 60%)',
          pointerEvents: 'none',
        }}
      />
      <div className="bf-container" style={{ position: 'relative' }}>
        <div className="bf-section-head" style={{ borderColor: '#fff' }}>
          <span className="bf-eyebrow bf-eyebrow-on-dark" style={{ borderColor: '#fff' }}>
            <span className="dot"></span>{t('diff.eyebrow', 'Where we fit')}
          </span>
          <div>
            <h2 style={{ color: '#fff' }}>
              {t('diff.titleA', 'Not another alert.')}
              <br />
              <span className="bf-serif-italic" style={{ color: '#999' }}>
                {t('diff.titleB', 'An invisible intelligence layer that contextualizes every patient for you.')}
              </span>
            </h2>
            <p className="bf-lead" style={{ marginTop: 20, maxWidth: '54ch', color: 'var(--bf-muted-2)' }}>
              {t(
                'diff.sub',
                'No prompts, no popups, no dashboards — just clarity where the work already happens.'
              )}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Differentiators;
